"use client";

import { DropdownMenuItem } from "@/components/ui/dropdown-menu";
import { apiClient } from "@/lib/client";
import { LogOut } from "lucide-react";
import { useRouter } from "next/navigation";
import { toast } from "sonner";

export const SignoutButton = ({ className }: { className: string }) => {
  const router = useRouter();

  const handleSignout = async () => {
    try {
      await apiClient.post("/logout", undefined);
      toast("サインアウトしました");
      router.push("/");
    } catch (err) {
      toast.error("エラーが発生しました", { description: err.response.data.message });
      console.error(err);
    }
  };

  return (
    <DropdownMenuItem onClick={handleSignout}>
      <LogOut className={className} />
      サインアウト
    </DropdownMenuItem>
  );
};
